import { createContext } from "react";

import type { ApplicationDomain } from "~/models/dto";

export const ApplicationDomainContext = createContext<ApplicationDomain | undefined>(undefined);
